// Copyright (c) Meta Platforms, Inc. and affiliates.

'use client';

import { createContext, use } from 'react';
export const TopNavSlotContext = /*#__PURE__*/createContext('start');
TopNavSlotContext.displayName = 'TopNavSlotContext';
export function useTopNavSlot() {
  return use(TopNavSlotContext);
}